export default{
    navbar:{
        home:"Home"
    }
}
